import dayjs from 'dayjs'
import { LoaderFunction, redirect } from 'react-router-dom'

import type { Slot } from '@/apiTypes.ts'
import { FormattedSlot } from '@/apiTypes.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface LoaderData {
  slots?: FormattedSlot[]
  loadTime?: number
  error?: string
}

const loader: LoaderFunction<LoaderData> = async ({ params }) => {
  const { selectedLocation, setError, setSelectedLocation, setSlots } =
    useAppointmentStore.getState()
  const { appointmentType, locationId } = params as {
    appointmentType: string
    locationId: string
    doctorId?: string
    category: string
  }

  const startTime = Date.now()
  try {
    const response = await fetchFromApi(
      `slots?type=${appointmentType}&location=${locationId}`,
    )

    if (!response.ok) {
      // Check for timeout error
      if (response.status === 504) {
        const errorData = await response.json()
        if (errorData.error === 'TIMEFF_TIMEOUT') {
          setError('timeffTimeoutVelthuis')
          return redirect('/error')
        }
      }
      setError('internalServerError')
      return redirect('/error')
    }
    const slots: Slot[] = await response.json()

    const formattedSlots = slots.map((slot) => ({
      ...slot,
      end: dayjs(slot.end),
      start: dayjs(slot.start),
    }))

    // If user lands on this page directly by URL, set the location from URL params
    if (!selectedLocation) {
      setSelectedLocation({
        emmaId: locationId,
      })
    }
    setSlots(formattedSlots)
    return { loadTime: Date.now() - startTime, slots: formattedSlots }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { LoaderData }
export { loader }
